import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  noPadding?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  ...props
}: CardProps) {
  return <div className={`bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden ${noPadding ? '' : 'p-4'} ${className}`} {...props} data-id="element-87">
      {children}
    </div>;
}